import { render, staticRenderFns } from "./WorkingDraft.vue?vue&type=template&id=05122b3a&scoped=true"
import script from "./WorkingDraft.vue?vue&type=script&lang=js"
export * from "./WorkingDraft.vue?vue&type=script&lang=js"
import style0 from "./WorkingDraft.vue?vue&type=style&index=0&id=05122b3a&prod&lang=scss&scoped=true"
import style1 from "./WorkingDraft.vue?vue&type=style&index=1&id=05122b3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05122b3a",
  null
  
)

export default component.exports